import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { Playbook } from "../../playbook/model/Playbook";

export const useGetSystemPlaybook = () => {
  const {
    data: systemPlaybook,
    call,
    isLoading,
    isFailed,
    setData: setSystemPlaybook,
  } = useApiPrivateRequest<Playbook>((response) => new Playbook(response));

  const getSystemPlaybook = async (id: string) => {
    await call(`/admin/playbooks/${id}`, "GET");
  };

  return {
    systemPlaybook,
    getSystemPlaybook,
    isLoading,
    isFailed,
    setSystemPlaybook,
  };
};
